var _path, _path2, _ellipse, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect2, _rect3, _polygon, _rect4, _path31, _path32, _path33, _polygon2, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse2, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _rect5, _path48, _ellipse3, _path49, _path50, _rect6, _rect7, _path51, _polygon3, _rect8, _path52, _polygon4, _rect9, _path53, _path54, _path55, _path56, _path57, _rect10, _path58, _ellipse4, _polygon5, _polygon6, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewStartupIdeaSearching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.63,162.33s13.3-2.05,19.44,9.89l8.86,12.61-7.84,2.39s-11.59-20.12-20.46-24.89Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306.16,612.99v5.06c0,2.01-1.17,3.84-3,4.69-7.11,3.3-26.49,10-54.26,1.7-2.12-.64-3.72-2.39-4.16-4.57l-1.37-6.89h62.79Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.72,
    cy: 612.99,
    rx: 31.39,
    ry: 9.93,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 269.49,
    y: 528.17,
    width: 8.14,
    height: 83.71,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.83,583.12l.51,10.22s16.88,10.74,25.57,1l-3.07-14.83-23.01,3.61Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23,591.81l.51,10.23s16.88,10.74,25.57,1l-3.07-14.83-23.01,3.6Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.66,419.15s1.85-9.56,12.35-12l19.23-.68s-2.75,9.61-1.38,12.7l-30.2-.02Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.37,397.56c-2.35,9.56-8.75,17.62-17.52,22.09h-53.69v-16.76l27-1.08c8.57-.32,16.35-5.07,20.54-12.55,1.22-2.19,2.35-4.49,3.39-6.83,4.88-10.95,7.92-22.64,9-34.58,2.12-23.25,10.58-21.13,10.58-21.13l.7,70.84Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321.84,334.34h36.94v161.94c0,17.61-14.27,31.88-31.88,31.88h-112.06c-10.55,0-19.11-8.56-19.11-19.11v-17.34l126.1-157.37Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M583.09,187.22l9.54-3.39,22.5,38.5,24.21,2.05s4.09-40.57,12.61-45.69l7.5,11.25-6.9,69.7s-30.94,15.19-49.39-17.54l-11.25-24.54s-1.32-17.39-8.82-30.34Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M666.27,169.49s-16.36,2.73-16.36,17.39c0,0,0,27.95-.34,53.52l3.41,45.65s24.88,16,65.79,3.41l9.55-84.89s7.16-24.2-5.12-29c0,0-16.36-7.15-33.4-8.18l-23.53,2.1Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M673.44,148.35l-1.35,28.42c0,.06,.07,.08,.1,.03l9.09-15.49,10.23-2.05,.68-18.07-1.7-3.41-17.05,10.57Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M434.93,394.21h-24.17c-15.11,0-27.58-11.8-28.44-26.88l-1.32-23.2h83.67l-1.32,23.2c-.84,15.08-13.32,26.88-28.42,26.88Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M548.73,176.05c0-69.51-56.36-125.86-125.87-125.87h-3.06c-68.08,1.57-123,58-122.88,126.18,.04,32.19,12.45,63.13,34.67,86.42,12.92,13.37,22.04,29.94,26.43,48l.83,3.54h128l.48-2.08c4.56-18.84,14-36.14,27.36-50.18,21.9-23.28,34.08-54.05,34.04-86.01Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M379.87,377.95h85.93c14.24-7.86,23.44-22.48,24.36-38.72l2.18-38.52h-138.97l2.16,38.52c.93,16.23,10.12,30.85,24.34,38.72Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M491.66,314.7l-135.08,10.89c-2.83,.23-5.32-1.87-5.57-4.7h0c-.22-2.83,1.88-5.32,4.71-5.57l135.11-10.94c2.83-.23,5.32,1.87,5.57,4.7h0c.25,2.85-1.85,5.36-4.7,5.61h-.04Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M491.63,335.14l-133.64,10.79c-2.83,.22-5.31-1.88-5.56-4.7h0c-.23-2.83,1.87-5.32,4.7-5.57l133.67-10.9c2.83-.22,5.32,1.88,5.56,4.71h0c.3,2.83-1.76,5.36-4.58,5.66,0,0,0,0,0,0h-.14Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M487.51,356.05l-123.15,9.92c-2.83,.22-5.32-1.88-5.57-4.71h0c-.23-2.84,1.87-5.33,4.71-5.58l123.14-9.94c2.83-.22,5.31,1.87,5.57,4.7h0c.24,2.84-1.86,5.35-4.7,5.61Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M479.26,363.26c4.18,0-2.23,6.77-2.23,6.77-.15,4.94-1.12,9.82-2.87,14.44l13,20.07-11.16,8.87-11.34-23s-9.89-3.55-7.51-9.41c1.47-3.7,6.27-4.11,6.27-4.11,4.72-5.16,10.04-9.73,15.84-13.63Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M468.24,401.43s6.34-9.77,13.34-9.84c.45,0,.87,.24,1.05,.66h0c1.2,2.75,3.07,5.19,5.55,6.88,1.36,.93,2.92,2.55,4.12,5.4,2.71,6.39,17.75,24.18,17.75,24.18l-21.78,22.6s-10.6-22.11-17.25-37.65c-1.66-3.87-2.6-8.01-2.78-12.22h0Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M521.68,347.64s-27.55,4.06-22.64,35.87,1.83,36.29,2.12,49.39,8.9,18.41,8.9,18.41l6.73-22.72s-3.36,4.31-2.24-12.43,1.39-38.23,1.39-38.23",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M443.99,419.47c-.78-1.26-1.48-2.56-2.1-3.89-1.67-3.6-2.28-7.61-1.86-11.55,.42-3.98-.11-9.96-.06-10.75,.05-.97-4.56-5.4-7.09-11.71-.39-.98-1.75-1.12-2.26-.2-.54,.97-.86,2.06-.93,3.19,.14,3.14,1.66,5.51,1.1,6-3,2.82-10.85-.5-13.24-1.35-5.27-1.85-7.84,.9-5.17,3.83,.94,1,3,.28,2.79,2.82s-.58,.34,.77,4.44,.86,5.39,3.93,7.45l7.95,5.33,6.34,13.6,9.83-7.21Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M508.78,520.99s11-16.23,38.31-17.14c17.45-.58,23.21,5.87,25.1,10.61s3.79,9.28,6.08,13.74c3.87,7.56,8.33,18.65,7.36,28.2-1.66,16.3-23,30.81-23,30.81,0,0,43.63,10.2,48.61,8.09s15.12,19.55,11.21,24.41-127.29-3.45-127.29-3.45c0,0-12.27-14.44-12.82-24.54s27.17-48.82,26.42-50.67,.02-20.06,.02-20.06Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M554.96,539.31s3.72,30.22-11.8,35.51l-39.88,16.16c-2.81,1.14-2.17,5.29,.85,5.52,20.82,1.59,61.95,4.45,69.98,2.84,10.84-2.19,26.12,19.76,26.12,19.76l-130,.32c-22.15,.05-34.85-17.46-30.42-31.61s64.98-55.9,64.98-55.9c0,0-3.18-15.24,30.05-26.55,17.67-10.75,20.11,33.96,20.11,33.96Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M505.01,529.09s2.3-17.5,1.45-22.67-1.49-11.86-.55-16.19c.09-.45-1.16-2.33-2.63-5.7h0c-1.84-4.23-3.08-8.7-3.7-13.27-1.12-8.76-.55-17.65,1.67-26.2,1.21-4.98,2.78-9.86,4.71-14.61,4.58-11.48,27.73-16.87,54.69-9.86,3.26,.81,6.13,2.74,8.11,5.45,8.33,11.22,5.23,35.6,1.58,52.8-2.12,10.01-1.61,20.29,.59,30.28,.34,1.53,.29,2.8-.42,3.49,0,0-31.52-11.24-63.78,14.6-.6,.47-1.18,1-1.78,1.46l.06,.41Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M600.51,603.05c.34-9,8.64-5.25,8.64-5.25,0,0,6.07-8.92,12-6.84s7.4,5.18,16.74,8.47,22.05,.71,25.5,9.6-1,13.87-22,12.24-26.65-2.3-26.65-2.3c0,0-14.94,2.14-14.23-15.92Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M617.31,590.95c-4.48,1.79-5,12.09,5.33,18.66s12.45,1,19,6.46,16.84,6.27,22.76,2,1.08-12.54-10-16.93-14.6,0-20.68-3.36-6.86-10.64-16.41-6.83Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M580.16,594.92c-5.82,1.14-11.38,3.35-16.4,6.52,0,0-3.31-4.87-6.41-.12s-.85,21.43,6.41,18.09c0,0,10.37,3.42,31.28,1.33s1-13.59,1-13.59l-15.88-12.23Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M582.16,595.05c-8.14-1.66-12.72,12.21-8.88,18.82s7.09,6.64,21.58,6.64,28.94,.52,28.05-13.37-20.7-10.36-25.42-8.61-11.03-2.61-15.33-3.48Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M519.77,416.09c-1.56,.29-12.37,.65-16.91,2.17-11.56,3.83-40.94,28.64-40.94,28.64l-20.2-35.66s-11.21,4.35-17.21,8.35l1.6,4.51c1.48,4.16,2.64,8.42,3.61,12.73,2.7,11.95,15.36,40.69,21.93,42.61,11.76,3.43,44.1-21,44.1-21,0,0,13.57-9,15-17.48",
    fill: "#ffc800",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M506.68,358.34c7.76-15.07,21.95-9.82,21.95-9.82,27.62-5.25,28.47,26.92,31,43.9s11.65,20.87,14.24,35.11c.4,3.43,.34,6.89-.19,10.3-.35-1.51-1.24-2.84-2.51-3.73,.53,18.41-10.36,27.53-11.05,28.07,7.71-10.6,6.77-17.47,6.77-17.47-3,10.79-14.52,21.4-14.52,21.4,0,0-9.85-2.22-14.47-16.57-4.09-12.76-9.54-17.25-9.86-17.45,3.74,7.33,6.5,15.11,8.21,23.16-5.41-7.96-10.28-16.26-14.6-24.86-19.2-36.64-16.87-51.89-16.87-51.89",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M477.03,370.05s-3.51,5.58-3.71,7.23",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.72,
    y: 453.71,
    width: 8.41,
    height: 172.76,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 319.29,
    y: 453.71,
    width: 8.41,
    height: 172.76,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "134.77 408.62 138.2 420.04 165.24 420.04 161.43 409.76 134.77 408.62",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122.96,
    y: 419.65,
    width: 59.04,
    height: 9.1,
    fill: "#d1d3d4",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M284.45,500.79c-7.23,3.81-6.85,11.81-6.85,11.81l.38,76.17c-3.51,2.7-7.6,4.54-11.95,5.39-12.75,2.68-25.37-2.34-25.37-2.34l-4.95-84.18c-.74-18.47,8.19-30.12,8.73-30.8l-39.61,13.33c-20.55,5.67-15.6,20.88-15.6,20.88l2.18,68.19c.1,2.3-1.07,4.48-3.05,5.66-2.94,1.61-6.16,2.67-9.49,3.11-6.34,.8-12.77,.49-19-.91-1.57-.33-2.75-1.65-2.89-3.25l-8.52-92.6c-1.14-28.56,19.83-35,19.83-35,21.73-.1,43.62-.1,65.66,0,25.93,.11,51.65,.34,77.15,.71-.06,4.55-.81,14.59-7.09,25.14-6.56,11.03-15.55,16.54-19.56,18.69Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M237.61,326.73l.76,102.45,68.17-.38,2.29-94.45s11.43-9.91,0-12.95c0,0-16-3.81-25.9-3.81,0,0-36.18-.38-45.32,9.14Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M258.93,326.34l5.34-7.62,.76-6.1s-10.28-1.9-6.1,13.72Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.27 305.02 264.27 318.73 266.93 324.81 266.94 324.81 272.27 313.4 281.03 310.34 280.46 292.45 274.55 285.59 264.27 305.02",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M209.88,419.65s-.37-9.06,12.36-12l22.77-.56s-1.37,9.91,0,13l-35.13-.44Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.1,624.05s-5.62-12.28,6.14-14.83l27.1-15.86s16.36,10.74,25.57,1c0,0,4.6,9.2,2,27.61l-60.81,2.08Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M216.5,632.71s-5.62-12.27,6.14-14.83l27.1-15.84s16.36,10.74,25.57,1c0,0,4.6,9.21,2,27.61l-60.81,2.06Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M682.62,180.77l-1.34-19.29c0-.1,.06-.19,.16-.2l10.06-2.02,2.39,8.86-11.05,12.73c-.07,.08-.21,.04-.22-.07Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M672.02,176.83l-5.39-15.13s.01-.06,.04-.06l5.84-.05-.43,15.23s-.05,.04-.06,0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M666.29,177.88l.32-16.22s0,0,0,0l3.75,10.52-3.66,5.83c-.12,.19-.42,.1-.41-.12Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 510.03,
    cy: 225.33,
    rx: 59.91,
    ry: 58.77,
    fill: "#fff",
    opacity: 0.48
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M591.08,230.77c.04-.96,.06-1.93,.06-2.91,0-43.26-36.42-78.34-81.34-78.34-41.8,0-76.25,30.36-80.83,69.44,1.59-41.92,37.37-75.43,81.28-75.43s81.36,35.08,81.36,78.34c0,2.97-.18,5.95-.53,8.9Z",
    fill: "#d1d3d4",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M591.95,217.56l145.3,12.59c7.08,.61,12.33,6.82,11.76,13.9h0c-.57,7.11-6.79,12.41-13.9,11.84-.03,0-.07,0-.1,0l-145.71-12.58,2.65-25.74Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M652.98,286.05s-11,52.14-5.77,89.22l9.84,140.61,26.07-.42,8.69-72.41,2.35-148.86s-23.83,2.86-41.18-8.14Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M757.28,493.48l-3.49,2.88-16.21,13.34-38.81-46.93s-8.26-9.17-13.33-42.29l-5.22-49.24s3.35-44.35-33.72-37.41c.69-12.5,2.14-24.95,4.35-37.27,.49-2.74,1-5.5,1.63-8.27l.49-2.21s25.56,16.08,65.81,3.41c0,0,11.27,16.86,5.47,71.32,0,0-2.32,52.9-.31,72.33,.31,2.94,1.02,5.81,2.12,8.55,3.05,7.6,12.16,27.74,31.21,51.79Z",
    fill: "#ffc800",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M661.7,525.33s-1.16,8.11-4.64,9.85c0,0,15.65,9.27,24.92,4.06l-.58-15.65-19.7,1.74Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M743.38,517.23l4.64,8.11s16.8-1.16,20.85-12.16l-9.26-12.75-16.23,16.8Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M783.94,531.7l-15.07-18.53s-4.63,11-20.85,12.16c0,0-25.56,27.85-15.06,36.5,0,0,5.21,7.53,20.27-6.37l30.71-23.76Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M681.97,539.25v24.33l-48.81,.47c-5.06,.04-9.19-4.03-9.23-9.08,0-.36,.02-.72,.05-1.08h0c.37-3.32,2.53-6.17,5.62-7.44l27.42-11.27s15.14,9.28,24.95,4.07Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 659.01,
    y: 98.25,
    width: 34.29,
    height: 54,
    rx: 17.15,
    ry: 17.15,
    transform: "translate(14.48 -62) rotate(5.31)",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M687.25,112.73s-30.51,7.16-30-9.72l.84-11.79c.09-1.47,1.27-2.63,2.74-2.7,8.63-.46,37-1.09,53,9.39,1.75,1.14,2.78,3.11,2.7,5.2-.41,9.73-3.11,38.89-20.93,44.15-3.2,.95-6.46-1.4-6.64-4.73-.11-2.07,.13-4.92,1.03-8.84l.51-9.71s-2.56-.52-3.92,2.55l.66-13.8Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.48,
    cy: 130.88,
    rx: 5.11,
    ry: 6.9,
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M681.29,161.48l1.34,19.3c0,.09-.1,.13-.16,.07-2.63-2.86-6.46-4.31-10.33-3.9-.03,0-.04-.02-.03-.05,3.03-5.14,6.06-10.29,9.08-15.45,.03-.05,.1-.03,.1,.02Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M637.62,262.9s-25.86-5.03-25.77-23.18c.03-6.18,7.18-9.7,11.93-5.77,.89,.74,1.83,1.67,2.8,2.82,1.57,1.82,3.27,3.53,5.08,5.12l7.32,5.67-1.37,15.34Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 653.58,
    y: 515.49,
    width: 33.02,
    height: 12.75,
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 734.11,
    y: 500.77,
    width: 33.02,
    height: 12.75,
    transform: "translate(-150.48 600.19) rotate(-39.94)",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M509.81,149.52c-41.8,0-76.25,30.36-80.83,69.44-.34,2.95-.52,5.93-.52,8.9,0,43.28,36.42,78.36,81.35,78.36s79.69-33.52,81.28-75.45c.04-.96,.06-1.93,.06-2.91,.02-43.26-36.42-78.34-81.34-78.34Zm.23,17.05c33.08,0,59.91,26.31,59.91,58.76s-26.78,58.77-59.91,58.77-59.87-26.31-59.87-58.77,26.78-58.76,59.87-58.76h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "273.03 329.93 272.27 312.79 282.56 308.98 284.07 318.12 273.03 329.93",
    fill: "#ffc800",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 419.65,
    width: 64.37,
    height: 9.52,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M242.56,402.14l41.89-.76s20.19,2.67,16.76-24.76c0,0-11.59-52.58,10.76-54.17,2.52-.18,5.02,.81,6.72,2.68,3.73,4.1,9.21,14.29,7.66,38.2,0,0,4.19,54.85-19.81,59l-65.51,1.9s.48-11.63,1.53-22.09Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.93 324.81 272.27 312.79 273.03 329.93 266.93 324.81",
    fill: "#ffc800",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 428.76,
    width: 255.84,
    height: 27.52,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M725.26,262.22c-11.59,21.48-88,2-88,2l.2-3,2.06-18.62c38,3,57.1,3.15,57.1,3.15,18.76,0,13.3-48.41,13.3-48.41,.25-16,10.21-18.06,15.5-18,1.99,0,3.86,.93,5.08,2.5,1.15,1.56,2.15,3.21,3,4.95,13.67,27.36-8.24,75.43-8.24,75.43Z",
    fill: "#919191",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M618.21,232.37s2.11,5.9,7.21,9.06",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M614.21,234.37s2.11,5.9,7.21,9.06",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M612.21,239.37s2.11,5.9,7.21,9.06",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M461.92,446.9s-3.87,2.05-5.14,9.37",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 244.01,
    y: 260.09,
    width: 35,
    height: 49,
    rx: 17.5,
    ry: 17.5,
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M244.22,277.45s-1.36-.89-2.96-3.03c-6.52-8.73-.6-21.09,10.25-22.1,3.13-.29,6.28-.93,8.95-2.15,0,0,28.82-8.85,36.05,17.43,0,0,9.32,26.71-15.06,37.8l-1-16.23-3.23-7s.76-10.66-9.14-8.76c0,0-17.14,2.67-21.33-.76,0,0-2.15,1.75-2.53,4.8Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.45,
    cy: 287.75,
    rx: 5.52,
    ry: 6.34,
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.37 408.62 200.28 409.76 184.28 336.25 190 335.49 206.37 408.62",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "81.82 336.25 97.82 409 200.28 409.76 184.28 336.25 81.82 336.25",
    fill: "#ffc800",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.86,
    cy: 372.29,
    rx: 8,
    ry: 8.19,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStartupIdeaSearching);
export default __webpack_public_path__ + "static/media/New-Startup-idea-searching.b88957c7e3ae37853cefe17cb72fa5f5.svg";
export { ForwardRef as ReactComponent };